import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LeaderboardMetric, MenuType } from "@/types/leader-board";
import { LeaderboardItemType } from "@/types/leader-board";
import UserLeaderBoardInfo from "./user-leader-board-info";
import Button from "@/components/atomics/button";
import MotionModal from "@/components/atomics/motion-modal";
import LeaderBoardBoost from "./leader-board-boost";
import ModalCard from "@/components/atomics/modal-card";

interface ShareInfoModalProps {
  className?: string;
  userInfo: LeaderboardItemType;
  selectedMenu: MenuType;
  metric: LeaderboardMetric;
  onClickClose: () => void;
}

export default function ShareInfoModal({
  className,
  userInfo,
  selectedMenu,
  metric,
  onClickClose,
}: ShareInfoModalProps) {
  const navigate = useNavigate();
  const [isOpenBoost, setIsOpenBoost] = useState(false);

  const getTitle = () => {
    switch (selectedMenu) {
      case "users":
        if (metric === "volume") return "user rank by volume";
        if (metric === "level") return "user rank by level";
        return "user rank";
      case "collections":
        if (metric === "volume") return "collection rank by volume";
        return "collection rank";
      case "nft":
        return "nft rank";
      default:
        return "rank";
    }
  };

  const getButtonText = () => {
    switch (selectedMenu) {
      case "users":
        return "GO TO USER";
      case "collections":
        return "GO TO COLLECTION";
      case "nft":
        return "GO TO NFT";
      default:
        return "GO TO";
    }
  };

  const handleGoTo = () => {
    onClickClose();
    switch (selectedMenu) {
      case "users":
        navigate(`/owner/${userInfo.address}`);
        break;
      case "collections":
        navigate(`/collection/${userInfo.address}`);
        break;
      case "nft":
        navigate(`/nft/${userInfo.address}`);
        break;
    }
  };

  const onClickRankBoost = () => {
    if (metric !== "all_stars") {
      return;
    }
    setIsOpenBoost(true);
  };

  const handleCloseBoost = () => {
    setIsOpenBoost(false);
  };

  return (
    <ModalCard title="share info" onClose={onClickClose} className={className}>
      <div className="flex flex-col px-[54px] py-[20px]">
        <span className="text-[24px] uppercase">{getTitle()}</span>
      </div>

      <UserLeaderBoardInfo
        className="!bg-[#2B2B2B]"
        circleColor="#2B2B2B"
        userInfo={userInfo}
        selectedMenu={selectedMenu}
        onClickRankBoost={onClickRankBoost}
        metric={metric}
      />

      <main className="flex flex-col justify-center items-center pt-[40px] pb-[50px] px-[54px]">
        <Button
          className="w-full text-[24px] hover:cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out"
          image="/assets/button.svg"
          text={getButtonText()}
          onClick={handleGoTo}
        />
      </main>

      <MotionModal isOpen={isOpenBoost}>
        <LeaderBoardBoost
          userInfo={userInfo}
          selectedMenu={selectedMenu}
          metric={metric}
          onClickClose={handleCloseBoost}
        />
      </MotionModal>
    </ModalCard>
  );
}
